import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setSelectedToken, toggleDestructionTool} from '../../redux/actions';
import styles from './Toolbar.styles';
import {ToolbarButton} from "./ToolbarButton";
import {selectDestructionToolActive, selectSelectedToken} from "../../redux/reducers/privateStateReducer/selectors";

const Toolbar = ({tokens}) => {
  const dispatch = useDispatch();
  const selectedToken = useSelector(selectSelectedToken);
  const destructionToolActive = useSelector(selectDestructionToolActive);

  const handleTokenSelect = (tokenId) => {
    // Если инструмент разрушения активен, выключаем его при выборе токена
    if (destructionToolActive) {
      dispatch(toggleDestructionTool());
    }
    dispatch(setSelectedToken(tokenId));
  };

  return (
    <div style={styles.container}>
      <div style={styles.tokensGrid}>
        {tokens.map(token => (
          <ToolbarButton
            key={token.id}
            tokenId={token.id}
            selected={selectedToken === token.id}
            image={token.image}
            label={token.label}
            onClick={() => handleTokenSelect(token.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default Toolbar;